import React from 'react';
import './Footer.css'
const Footer = () => {
    return (
        
        <div class="site-footer">
          <div class="container">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <h6>About</h6>
                <p class="text-justify">An action camera is a compact, rugged, handheld or mountable digital camera that is designed for capture what you see when you are immersing in a trip, sport or event. ... Nowadays, action cameras are quite powerful and able to help record high-quality videos & photos in all kinds of environments.</p>
              </div>
    
              <div class="col-xs-6 col-md-3">
                <h6>Categories of camera</h6>
                <ul class="footer-links">
                  <li>Go Pro</li>
                  <li>Sj cam</li>
                  <li>Eken 4k</li>
                  <li>Xiomi Mijia</li>
                  <li>Akaso</li>
            
                </ul>
              </div>
    
            </div>
           </div>
    </div>
    );
};

export default Footer;